<template>
  <div class="flex flex-col gap-1">
    <program-teaser-text :program="program" :ellipsis="ellipsis" />
    <program-teaser-action v-if="!removeAction" :program="program" />
  </div>
</template>

<script lang="ts" setup>
import ProgramTeaserText from '@/program/components/program-teaser/ProgramTeaserText.vue';
import ProgramTeaserAction from '@/program/components/program-teaser/ProgramTeaserAction.vue';
import {ProgramSnapshot} from "@/program/interfaces/Program";

withDefaults(defineProps<{
    /** The program to get the teaser from. */
    program: ProgramSnapshot

    removeAction?: boolean

    /** Enable text ellipsis after 3 lines */
    ellipsis?: boolean
}>(), { removeAction: false, ellipsis: false });
</script>
